var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVentaPagado(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 92.89 128.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.94;}.cls-2{fill:#cce47e;}.cls-3{fill:#eef1f8;}.cls-4{fill:#f3d585;}.cls-5{fill:#df6464;}.cls-6{fill:#eec173;}.cls-7{opacity:0.97;}.cls-8{fill:#afb7cf;}.cls-9{fill:#c7cddf;}.cls-10{fill:#d7dceb;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 50zzz") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WEB_VIEW",
    "data-name": "WEB VIEW"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.47,123.86h-84A4.42,4.42,0,0,1,0,119.43V4.42A4.42,4.42,0,0,1,4.42,0H88.47a4.42,4.42,0,0,1,4.42,4.42v115A4.43,4.43,0,0,1,88.47,123.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M84,106.16V17.69A8.84,8.84,0,0,1,75.2,8.85H17.69a8.84,8.84,0,0,1-8.84,8.84v88.47A8.84,8.84,0,0,1,17.69,115H75.2A8.84,8.84,0,0,1,84,106.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M75.2,117.22H17.69A2.21,2.21,0,0,1,15.48,115a6.64,6.64,0,0,0-6.63-6.64,2.22,2.22,0,0,1-2.22-2.21V17.69a2.22,2.22,0,0,1,2.22-2.21,6.63,6.63,0,0,0,6.63-6.63,2.22,2.22,0,0,1,2.21-2.22H75.2a2.22,2.22,0,0,1,2.21,2.22A6.64,6.64,0,0,0,84,15.48a2.21,2.21,0,0,1,2.22,2.21v88.47A2.21,2.21,0,0,1,84,108.37,6.65,6.65,0,0,0,77.41,115,2.21,2.21,0,0,1,75.2,117.22ZM19.68,112.8H73.21a11.09,11.09,0,0,1,8.62-8.63V19.68a11.09,11.09,0,0,1-8.62-8.62H19.68a11.09,11.09,0,0,1-8.62,8.62v84.49A11.09,11.09,0,0,1,19.68,112.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M77.85,124.71l-5.15-1.27-3.16,4.26a1.42,1.42,0,0,1-2.49-.37L59.72,107l12.48-4.49,7.33,20.38A1.42,1.42,0,0,1,77.85,124.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M46,124.71l5.15-1.27,3.16,4.26a1.42,1.42,0,0,0,2.49-.37L64.14,107l-12.49-4.49-7.33,20.38A1.43,1.43,0,0,0,46,124.71Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 61.93,
    cy: 95.1,
    r: 15.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 61.93,
    cy: 95.1,
    r: 11.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M66.35,35.39H26.54a2.21,2.21,0,0,1-2.21-2.21h0A2.21,2.21,0,0,1,26.54,31H66.35a2.21,2.21,0,0,1,2.21,2.22h0A2.21,2.21,0,0,1,66.35,35.39Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M28.75,53.08H24.33a2.21,2.21,0,0,1-2.21-2.21h0a2.21,2.21,0,0,1,2.21-2.21h4.42A2.21,2.21,0,0,1,31,50.87h0A2.21,2.21,0,0,1,28.75,53.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M68.56,53.08h-31a2.21,2.21,0,0,1-2.21-2.21h0a2.21,2.21,0,0,1,2.21-2.21h31a2.21,2.21,0,0,1,2.21,2.21h0A2.21,2.21,0,0,1,68.56,53.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M28.75,61.93H24.33a2.21,2.21,0,0,1-2.21-2.21h0a2.21,2.21,0,0,1,2.21-2.22h4.42A2.21,2.21,0,0,1,31,59.72h0A2.21,2.21,0,0,1,28.75,61.93Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("text", null)), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M28.75,70.77H24.33a2.21,2.21,0,0,1-2.21-2.21h0a2.21,2.21,0,0,1,2.21-2.21h4.42A2.21,2.21,0,0,1,31,68.56h0A2.21,2.21,0,0,1,28.75,70.77Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M68.56,70.77h-31a2.21,2.21,0,0,1-2.21-2.21h0a2.21,2.21,0,0,1,2.21-2.21h31a2.21,2.21,0,0,1,2.21,2.21h0A2.21,2.21,0,0,1,68.56,70.77Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M39.81,90.68H24.33a2.21,2.21,0,0,1-2.21-2.21h0a2.21,2.21,0,0,1,2.21-2.21H39.81A2.21,2.21,0,0,1,42,88.47h0A2.21,2.21,0,0,1,39.81,90.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M33.18,99.53H24.33a2.21,2.21,0,0,1-2.21-2.22h0a2.21,2.21,0,0,1,2.21-2.21h8.85a2.21,2.21,0,0,1,2.21,2.21h0A2.21,2.21,0,0,1,33.18,99.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M59.72,26.54H33.18A2.21,2.21,0,0,1,31,24.33h0a2.21,2.21,0,0,1,2.22-2.21H59.72a2.21,2.21,0,0,1,2.21,2.21h0A2.21,2.21,0,0,1,59.72,26.54Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVentaPagado);
export default __webpack_public_path__ + "static/media/venta-pagado.46f7a6ad0793cdef6f99707b715aceeb.svg";
export { ForwardRef as ReactComponent };